import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Autocomplete, Backdrop, Button, CircularProgress, Collapse, IconButton, Pagination, Paper, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Box, Stack, styled } from "@mui/system";
import { AxiosError } from "axios";
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as constants from "../../../constants";
import CustomAutocomplete from "../../../shared/AutoComplete";
import ContainedButton from "../../../shared/Button/CustomContainedButton";
import CustomTextField from "../../../shared/CustomTextFeild";
import { RootState } from "../../../store/store";
import { downloadAsFile, downloadAsPDF, formatToReadableDate } from "../../core/Util";
import basestyle from "../../CSS/Base.module.css";
import FilterPopUpBankDetails from "../../PopUp/FilterPopUpBankDetails";
import { getAccountSummaryByRAN, getCheckImage, getDownloadMasterTransaction, getMasterTransactionFilter, getPreviousMonthList, patchMasterTransactionNotes } from "../services/Summary/accountSummaryService";
import { SectionTitle, StyledOneChildContainer, StyledParentContainer, StyledTwoChildContainer } from "../StyledComponents/Container";
import CommonUtilities from "../Utils/CommonUtilities";
import { formatCurrency } from "../Utils/formatUtils";
import { notifyUser } from "../Utils/notifyUser";

const StyledTable = styled(Table)(({ theme }) => ({
    minWidth: 650,
    "& .MuiTableCell-root": {
        border: "0.5px solid #f2f6fa",
    },
}));
// Make bankingSearchVo global to the component
let bankingSearchVo: any = {};
function SummaryDetails() {
    const [expandedRow, setExpandedRow] = useState<number | null>(null);
    const [descriptionMap, setDescriptionMap] = useState<{ [key: number]: string }>({});
    const [openPopUp, setOpenPopUp] = useState(false);
    const [openDownloadPopUp, setOpenDownloadPopUp] = useState(false);
    const [accountSumaryDetails, setAccountSummaryDetails] = useState<any>({});
    const [montlyEndDateList, setMontlyEndDateList] = useState([]);
    const [noRecordsFound, setNoRecordsFound] = useState("");
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const bnkDetails = location.state?.bnkDetails;
    const userInfo = useSelector((state: RootState) => state.auth);

    const { t } = useTranslation();
    const dispatch = useDispatch();
    // Pagination state retention (like FundsListing)
    const retain = useSelector((state: RootState) => state.table.checkingSummary);
    const [page, setPage] = useState(retain?.page || 0);
    const [rowsPerPage, setRowsPerPage] = useState(retain?.pageSize || 5);
    const navigate = useNavigate();
    // Save pagination state to Redux on change
    useEffect(() => {
        dispatch({
            type: "table/setPagination",
            payload: { tableKey: "checkingSummary", page, pageSize: rowsPerPage },
        });
    }, [page, rowsPerPage, dispatch]);
    const [tableCheckingData, setTableCheckingData] = useState([]);
    const [totalEntries, setTotalEntries] = useState(0);
    const [titleName, setTitleName] = useState("");
    const [checkImageData, setCheckImageData] = useState<Record<number, string | { front: string; back: string }>>({});
    const tableData = [
        { label: "Status Closing Available", value: accountSumaryDetails?.statusClosingAvailableBalance },
        { label: "Opening Available Balance", value: accountSumaryDetails?.openingAvailableBalance },
        { label: "Total Debits", value: accountSumaryDetails?.totalDebitBalance, isHighlighted: false },
        { label: "Total Credits", value: accountSumaryDetails?.totalCreditBalance },
        { label: "Current Available", value: accountSumaryDetails?.currentAvailableBalance }
    ];

    const translate = t as (key: string) => string;
    const [blackdropFlag, setBlackdropFlag] = useState(false)
    const baiCodeOptions = [
        { name: "All Types", code: "All Types" },
        { name: "All Deposits", code: "CR DET" },
        { name: "All Withdrawals", code: "DB DET" },
    ];
    // Retain selectedBaiCode in Redux table slice
    const retainedBaiCode = retain?.filters?.baiCode
        ? baiCodeOptions.find(opt => opt.code === retain.filters.baiCode) || baiCodeOptions[0]
        : baiCodeOptions[0];
    const [selectedBaiCode, setSelectedBaiCode] = useState(retainedBaiCode);
        // Save selectedBaiCode to Redux on change
        useEffect(() => {
            dispatch({
                type: "table/setTableFilters",
                payload: {
                    tableKey: "checkingSummary",
                    filters: { ...retain?.filters, baiCode: selectedBaiCode?.code },
                },
            });
        }, [selectedBaiCode, dispatch]);
    const [selectedPrintView, setSelectedPrintView] = useState<"front" | "back" | "both">("front");
    const [searchPayload, setSearchPayload] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);




    const handleExpandClick = (index: number, row: any) => {
        if (expandedRow === index) {
            setExpandedRow(null);
        } else {
            setExpandedRow(index);
            setDescriptionMap((prev) => ({
                ...prev,
                [index]: row.dnlDesc || ""
            }));

            if (row.transactionCheckReference) {
                const checkImageVo = {
                    accountNumber: row?.accountNumber,
                    x9FilePath: null,
                    checkNumber: row?.transactionCheckReference,
                    routingNumber: row?.routingNumber,
                    view: "front"
                };
                // Call image API when expanding
                getCheckImageById(checkImageVo, index);
            }
        }
    };

    const formatAmount = (amount: number) => {
        if (amount == null) return "$0.00";

        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    };

    const handlePopUpClose = () => {
        setOpenPopUp(false);
    };
    const handleDownloadPopUpClose = () => {
        setOpenDownloadPopUp(false);
    };
    const handleFilter = () => {
        setOpenPopUp(true);
        setTitleName("Filter");
    };

    function handleConfirm(filterData: any) {
        const matchedOption = baiCodeOptions.find(
            (option) => option.code === filterData?.baiCode
        );
        setExpandedRow(null);  
        setSelectedBaiCode(matchedOption || baiCodeOptions[0]);
        bankingSearchVo = {
            baiCode: filterData?.baiCode,
            amount: filterData?.amountAll,
            fromTransPostingDate: filterData?.fromDate,
            toTransPostingDate: filterData?.toDate,
            maxAmount: filterData?.amountMax,
            minAmount: filterData?.amountMin,
            maxCheckNumber: filterData?.checkMax,
            minCheckNumber: filterData?.checkMin,
            checkNumber: filterData?.checkAll,
            ...(bnkDetails
                ? {
                    routingNumber: bnkDetails?.routingNumber,
                    accountNumber: bnkDetails?.accountNumber,
                }
                : { participantId: userInfo?.defaultParticipantId }),
            month: filterData?.monthEndDate ? Math.floor(new Date(filterData.monthEndDate).getTime()) : null,
            isActive: "Y",
            page: 1,
            size: rowsPerPage,
        };
        setPage(0);
        setSearchPayload(bankingSearchVo); // store the search
        getMasterTransaction(bankingSearchVo);
        if (titleName === "Download" && filterData?.fileType) {
            const downloadSearchVo = {
                ...bankingSearchVo,
                fileType: filterData?.fileType,
                page: -1,
                size: -1,
            };
            getDownloadMasterTans(downloadSearchVo);
        }
        handlePopUpClose();
    }
    async function getDownloadMasterTans(checkingSearch: any) {
        const cleanedSearch: any = cleanObject(checkingSearch);
        setBlackdropFlag(true)
        try {
            const resMasterTransction = await getDownloadMasterTransaction(cleanedSearch);
            if (resMasterTransction.status === constants.STATUS_CODES.SUCCESS) {
                const base64Data = resMasterTransction?.data?.data;
                if (base64Data) {
                    const decodedText = atob(base64Data); // Decode Base64 
                    switch (checkingSearch.fileType) {
                        case constants.FILE_TYPE_PDF:
                            downloadAsPDF(decodedText, constants.FILE_NAME_PDF);
                            break;
                        case constants.FILE_TYPE_CSV:
                            downloadAsFile(decodedText, constants.FILE_NAME_CSV, "text/csv");
                            break;
                        case constants.FILE_TYPE_TXT:
                            downloadAsFile(decodedText, constants.FILE_NAME_TXT, "text/plain");
                            break;
                        default:
                            notifyUser(constants.UNSUPPORTED_FILE_TYPE, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'));
                    }
                }
                notifyUser(resMasterTransction?.data?.message, constants.NOTIFY_STATUS.SUCCESS, translate('summaryDetails'));
            } else {
                notifyUser(resMasterTransction?.data?.message, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'));
            }
            handleDownloadPopUpClose();
        } catch (error: any) {
            if (error instanceof AxiosError) {
                notifyUser(error.response?.data?.message || constants.SOMETHING_WENT_WORNG, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'));
            } else {
                notifyUser(constants.AN_UNEXPECTED_ERROR_OCCURED, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'));
            }
        } finally {
            setBlackdropFlag(false)
        }
    }
    const handleDownload = () => {
        // setOpenDownloadPopUp(true);
        setOpenPopUp(true);
        setTitleName("Download");
    };
    const printStatement = () => {
        // Open a blank popup synchronously to avoid browser block
        const printWindow = window.open("", "_blank", "width=900,height=700");
        if (!printWindow) {
            alert("Popup blocked! Please allow popups for this site.");
            return;
        }
        printWindow.document.write(`
            <html><head><title>Loading...</title></head>
            <body><h2>Loading transaction data...</h2></body>
            </html>
        `);
        const printSearchVO = {
            ...bankingSearchVo,
            page: -1,
            size: -1
        };
        getPrintTransaction(printSearchVO, printWindow);
    };
    async function getPrintTransaction(checkingSearch: any, printWindow: Window | null) {
        const cleanedSearch: any = cleanObject(checkingSearch);
        try {
            const res = await getMasterTransactionFilter(cleanedSearch);

            if (res?.status === constants.STATUS_CODES.SUCCESS) {
                const transactionData = res?.data?.data || [];
                openPrintWindow(transactionData, printWindow); // always call this
            } else {
                openPrintWindow([], printWindow); // show "No records found"
            }
        } catch (error: any) {
            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write("<h3>Error loading data. Please try again later.</h3>");
                printWindow.document.close();
            }
        }
    }

    const openPrintWindow = (tableData: any[], printWindow: Window | null) => {
        if (!printWindow) return;

        const formatAmount = (amount: number) =>
            new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }).format(amount);

        const hasData = Array.isArray(tableData) && tableData.length > 0;

        const tableRows = hasData
            ? tableData.map((row, index) => {
                const date = dayjs(row.postingDate).format("MM/DD/YYYY hh:mm A");
                const desc = row.transactionDesc || "";
                const checkNo = row.transactionCheckReference === "0" ? "" : row.transactionCheckReference || "";
                const deposit = row.masterTransactionType === "CR DET" ? formatAmount(row.amount) : "";
                const withdrawal = row.masterTransactionType === "DB DET" ? formatAmount(row.amount) : "";

                return `
                      <tr style="background-color: ${index % 2 === 0 ? '#f1f3f4' : '#fff'};">
                          <td style="text-align:center; border:1px solid #ddd;">${date}</td>
                          <td style="text-align:left; border:1px solid #ddd;">${desc}</td>
                          <td style="text-align:center; border:1px solid #ddd;">${checkNo}</td>
                          <td style="text-align:right; color:green; border:1px solid #ddd;">${deposit}</td>
                          <td style="text-align:right; color:red; border:1px solid #ddd;">${withdrawal}</td>
                      </tr>
                  `;
            }).join("")
            : `<tr>
                  <td colspan="5">
                      No records found
                  </td>
               </tr>`;

        const bodyName = bnkDetails ? "Banking" : "Checking";

        const tableHtml = `
            <html>
            <head>
                <title>Print Statement</title>
                <style>
                    body { font-family: Arial, sans-serif; padding: 20px; }
                    table { border-collapse: collapse; width: 100%; margin-top: 20px; }
                    th, td { padding: 8px; }
                    th { background-color: #f5f5f5; border: 1px solid #ddd; }
                </style>
            </head>
            <body>
                <h2>${bodyName} Statement</h2>
                <table>
                    <thead>
                        <tr>
                            <th style="text-align:center;">Date</th>
                            <th style="text-align:left;">Description</th>
                            <th style="text-align:center;">Check Number</th>
                            <th style="text-align:right;">Deposit</th>
                            <th style="text-align:right;">Withdrawal</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRows}
                    </tbody>
                </table>
                <script>
                    window.onload = function() {
                        window.print();
                    }
                </script>
            </body>
            </html>
        `;

        printWindow.document.open();
        printWindow.document.write(tableHtml);
        printWindow.document.close();
    };
    function handleBack() {
        navigate("/summary");
    }

    useEffect(() => {
        fetchMasterTransaction();
    }, [page, rowsPerPage]);

    useEffect(() => {
        getMonthsList(userInfo?.defaultParticipantId, userInfo?.clientId);
        if (bnkDetails) {
            getAccountSummary(bnkDetails?.routingNumber, bnkDetails?.accountNumber, userInfo?.clientId);
        }
    }, [])

    const fetchMasterTransaction = (newPage = page, newSize = rowsPerPage) => {
        bankingSearchVo = {
            ...(searchPayload || {}),
            baiCode: selectedBaiCode?.code,
            ...(bnkDetails
                ? {
                    routingNumber: bnkDetails?.routingNumber,
                    accountNumber: bnkDetails?.accountNumber,
                }
                : { participantId: userInfo?.defaultParticipantId }),

            // Always include these fields
            isActive: "Y",
            page: newPage + 1, // Assuming API is 1-based
            size: newSize,
        };
console.log("Fetching with search criteria:", bankingSearchVo);
        getMasterTransaction(bankingSearchVo);
    };



    async function getAccountSummary(routingNumber: string, accountNumber: string, clientId: number) {
        setIsLoading(true);
        try {
            const resAccountSummary = await getAccountSummaryByRAN(routingNumber, accountNumber, clientId);
            if (resAccountSummary.status === constants.STATUS_CODES.SUCCESS) {
                setAccountSummaryDetails(resAccountSummary?.data?.data)
            }
        } catch (error: any) {
            if (error instanceof AxiosError) {
                setNoRecordsFound(error.response?.data?.message || "Something went wrong");
            } else {
                setNoRecordsFound("An unexpected error occurred");
            }
        } finally {
            setIsLoading(false);
        }
    }
    function cleanObject(obj: Record<string, any>) {
        return Object.fromEntries(
            Object.entries(obj).filter(
                ([_, value]) =>
                    value !== null &&
                    value !== "" &&
                    value !== undefined
            )
        );
    }
    async function getMasterTransaction(checkingSearch: any) {
        const cleanedSearch: any = cleanObject(checkingSearch);
        try {
            setLoading(true); // Start loading
            const resMasterTransction = await getMasterTransactionFilter(cleanedSearch);
            if (resMasterTransction.status === constants.STATUS_CODES.SUCCESS) {
                setTableCheckingData(resMasterTransction?.data?.data || []);
                setTotalEntries(resMasterTransction?.data?.totalRecordCount || 0);
            }
        } catch (error: any) {
            if (error instanceof AxiosError) {
                notifyUser(error.response?.data?.message, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'));
                setTableCheckingData([]);
                setTotalEntries(0);
            } else {
                notifyUser(constants.ERROR_IN_MASTER_TRANSACTION, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'));
                setTableCheckingData([]);
                setTotalEntries(0);
            }
        } finally {
            setLoading(false); // Stop loading in both success/fail
        }
    }
    async function getMonthsList(numberOfMonths: number, clientId: number) {
        try {
            const resMontlyList = await getPreviousMonthList(numberOfMonths, clientId);
            if (resMontlyList.status === constants.STATUS_CODES.SUCCESS) {
                setMontlyEndDateList(resMontlyList.data.data)
            } else {
                setMontlyEndDateList([])
            }
        } catch (error: any) {
            if (error instanceof AxiosError) {
                console.error(error.response?.data?.message || "Something went wrong");
            } else {
                console.error("An unexpected error occurred");
            }
        }
    }
    const handleDescriptionChange = (index: number, value: string) => {
        if (value.trim() === "") return; // Skip updating if value is empty or only spaces

        setDescriptionMap((prev) => ({
            ...prev,
            [index]: value
        }));
    };

    const handleDescriptionBlur = async (index: number, row: any) => {
        const currentDesc = descriptionMap[index]?.trim() ?? "";
        const originalDesc = row.dnlDesc?.trim?.() ?? "";

        if (currentDesc !== originalDesc) {
            const notesSavedVO = {
                dnlDesc: currentDesc
            };
            await patchNotesSave(row.masterTransactionId, notesSavedVO);
        }
    };

    async function patchNotesSave(masterTransactionId: number, notesVO: any) {
        try {
            const resNotesSaved = await patchMasterTransactionNotes(masterTransactionId, notesVO);
            if (resNotesSaved.status === constants.STATUS_CODES.SUCCESS) {
                notifyUser(resNotesSaved?.data?.message, constants.NOTIFY_STATUS.SUCCESS, translate('summaryDetails'))
            }
        } catch (error: any) {
            if (error instanceof AxiosError) {
                notifyUser(error.response?.data?.message || constants.SOMETHING_WENT_WORNG, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'))
            } else {
                notifyUser(constants.AN_UNEXPECTED_ERROR_OCCURED, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'))
            }
        }
    }
    const handleBaiCodeChange = (baiCode: any) => {
        if (bnkDetails) {
             bankingSearchVo = {
                baiCode: baiCode,
                accountNumber: bnkDetails?.accountNumber,
                routingNumber: bnkDetails?.routingNumber,
                isActive: "Y",
                page: 1,
                size: rowsPerPage,
            };
            setPage(0);
            getMasterTransaction(bankingSearchVo);

        } else {
             bankingSearchVo = {
                baiCode: baiCode,
                ...(bnkDetails
                    ? {
                        routingNumber: bnkDetails?.routingNumber,
                        accountNumber: bnkDetails?.accountNumber,
                    }
                    : { participantId: userInfo?.defaultParticipantId, }),
                isActive: "Y",
                page: 1,
                size: rowsPerPage,
            };
            setPage(0);
            getMasterTransaction(bankingSearchVo);
        }
    };

    const handleGetCheckImage = async (row: any, index: number, view: "front" | "back" | "both") => {
        setSelectedPrintView(view)
        if (view === "both") {
            // First get the front image
            const frontImageVo = {
                accountNumber: row?.accountNumber,
                x9FilePath: null,
                checkNumber: row?.transactionCheckReference,
                routingNumber: row?.routingNumber,
                view: "front",
            };
            const backImageVo = {
                ...frontImageVo,
                view: "back",
            };
            try {
                const [frontRes, backRes] = await Promise.all([
                    getCheckImage(frontImageVo),
                    getCheckImage(backImageVo)
                ]);
                if (frontRes.status === constants.STATUS_CODES.SUCCESS && backRes.status === constants.STATUS_CODES.SUCCESS) {
                    setCheckImageData((prev: any) => ({
                        ...prev,
                        [index]: {
                            front: frontRes.data.data,
                            back: backRes.data.data,
                        }
                    }));
                }
            } catch (error: any) {
                console.error(error?.response?.data?.message || "Error fetching both images");
            }
        } else {
            const checkImageVo = {
                accountNumber: row?.accountNumber,
                x9FilePath: null,
                checkNumber: row?.transactionCheckReference,
                routingNumber: row?.routingNumber,
                view: view,
            };
            try {
                const resCheckImage = await getCheckImage(checkImageVo);
                if (resCheckImage.status === constants.STATUS_CODES.SUCCESS) {
                    setCheckImageData((prev: any) => ({
                        ...prev,
                        [index]: {
                            [view]: resCheckImage.data.data,
                        }
                    }));
                }
            } catch (error: any) {
                console.error(error?.response?.data?.message || "Error fetching image");
            }
        }
    };

    async function getCheckImageById(checkesVO: any, index: number) {
        try {
            const resCheckImage = await getCheckImage(checkesVO);
            if (resCheckImage.status === constants.STATUS_CODES.SUCCESS) {
                setCheckImageData(prev => ({
                    ...prev,
                    [index]: resCheckImage.data.data,
                }));
            }
        } catch (error: any) {
            if (error instanceof AxiosError) {
                console.error(error.response?.data?.message || "Something went wrong");
            } else {
                console.error("An unexpected error occurred");
            }
        }
    }
    const handlePrintImage = (row: any, index: number, view: "front" | "back" | "both") => {
        const imageData = checkImageData[index];
        const windowFeatures = "width=800,height=600,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes";

        if (!imageData) {
            notifyUser(constants.NO_IMAGE_TO_PRINT, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'))
            return;
        }

        const newWindow = window.open('', 'PrintWindow', windowFeatures);

        if (newWindow) {
            const imagesHtml: string[] = [];

            if (view === "both") {
                if (typeof imageData === "object" && imageData !== null) {
                    imagesHtml.push(
                        `<img src="data:image/png;base64,${imageData.front}" style="max-width:100%;height:auto;" /><br/><br/>`,
                        `<img src="data:image/png;base64,${imageData.back}" style="max-width:100%;height:auto;" />`
                    );
                } else {
                    notifyUser(constants.FRONT_AND_BANK_IMAGES_ARE_NOT_LOADED_YET, constants.NOTIFY_STATUS.ERROR, translate('summaryDetails'))
                    return;
                }
            } else {
                if (typeof imageData === "object" && imageData !== null && imageData[view]) {
                    imagesHtml.push(`<img src="data:image/png;base64,${imageData[view]}" style="max-width:100%;height:auto;" />`);
                } else if (typeof imageData === "string") {
                    imagesHtml.push(`<img src="data:image/png;base64,${imageData}" style="max-width:100%;height:auto;" />`);
                }
            }

            newWindow.document.write(`
                <html>
                <head><title>Print Check</title></head>
                <body style='text-align:center;'>
                    ${imagesHtml.join("")}
                    <script>
                        window.onload = function() {
                            window.print();
                        };
                    </script>
                </body>
                </html>
            `);

            newWindow.document.close();
            newWindow.focus();
        }
    };


    return (
        <StyledParentContainer>
            <StyledOneChildContainer>
                <StyledTwoChildContainer sx={{ border: "none" }}>
                    <SectionTitle>
                        {bnkDetails
                            ? `${bnkDetails.bankName}${bnkDetails.accountNumber ? ` - ${bnkDetails.accountNumber.slice(-4)}` : ""}`
                            : "Checking"}
                    </SectionTitle>

                    {bnkDetails && <Box sx={{ mt: 2, width: "100%" }}>
                        <Typography className={basestyle.accountSummary} sx={{ fontSize: "20px" }}>
                            {` ${translate("accountSummaryasOn")}  ${formatToReadableDate(accountSumaryDetails?.txPostingDate)}`}
                        </Typography>
                    </Box>}
                    {bnkDetails && <TableContainer>
                        <Table>
                            <TableBody>
                                {tableData.map((row, index) => (
                                    <TableRow key={index} className={row.isHighlighted ? basestyle.highlightedRow : ""}>
                                        <TableCell sx={{ borderBottom: "1px solid #F1F3F4", border: "none" }}>
                                            {row.label}
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderBottom: "1px solid #F1F3F4",
                                                border: "none",
                                                textAlign: "right" // Align amount to right
                                            }}
                                        >
                                            {isLoading ? (
                                                <CircularProgress size={20} />
                                            ) : (
                                                formatCurrency(row.value)
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>}
                    {/* Filter and Buttons Row (Responsive Design) */}
                    <Box sx={{ width: "100%", px: 1.5 }}>
                        <div className="search-fields-container">
                            <div className="left-fields">
                                {/* Left Side: Dropdown */}
                                <Typography sx={{ fontSize: "16px", mt: 1 }}>{translate("showing")}</Typography>
                                <CustomAutocomplete
                                    size="small"
                                    sx={{ width: "205px" }}
                                    options={baiCodeOptions}
                                    value={selectedBaiCode}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setSelectedBaiCode(newValue);
                                            handleBaiCodeChange(newValue?.code); // This will call fetchMasterTransaction with updated baiCode
                                            setExpandedRow(null);
                                        }
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                    placeholder="Select Type"
                                />

                                <Button
                                    variant="outlined"
                                    sx={{
                                        backgroundColor: "#E8F4F8", // Light blue background
                                        color: "black",
                                        borderColor: "#58A6C0", // Border color similar to your reference
                                        textTransform: "none", // Prevent uppercase text 
                                        "&:hover": {
                                            backgroundColor: "#D0ECF2", // Slightly darker hover effect
                                        },
                                    }}
                                    onClick={handleFilter}
                                    endIcon={<KeyboardArrowDownIcon />}
                                >
                                    {translate("filter")}
                                </Button>
                            </div>
                            {/* Right Side: Buttons */}
                            <div className="right-fields">
                                <ContainedButton onClick={handleDownload} >
                                    {translate("download")}
                                </ContainedButton>
                                <ContainedButton onClick={printStatement} sx={{ ml: 1 }}>
                                    {translate("printStatements")}
                                </ContainedButton>
                            </div>
                        </div>
                        <Box sx={{ width: "100%", mt: 3 }}>
                            <TableContainer
                                component={Paper}
                                sx={{ overflow: "auto", maxHeight: "60vh", }}
                            >
                                <StyledTable
                                    stickyHeader
                                    aria-label="sticky table"
                                    size="small"
                                    sx={{
                                        [`& .${tableCellClasses.root}`]: {
                                            borderBottom: "none",
                                            borderTop: "none",
                                        },
                                    }}
                                >
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: "#F5F5F5" }}>
                                            <TableCell align="center" className="cellTask">Date</TableCell>
                                            <TableCell align="left" className="cellTask">Description</TableCell>
                                            <TableCell align="center" className="cellTask">Check Number</TableCell>
                                            <TableCell align="right" className="cellTask">Deposit</TableCell>
                                            <TableCell align="right" className="cellTask">Withdrawal</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ? (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" sx={{ border: "1px solid #ddd", backgroundColor: "#fff" }}>
                                                    Loading...
                                                </TableCell>
                                            </TableRow>
                                        ) : tableCheckingData.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center" sx={{ border: "1px solid #ddd", backgroundColor: "#fff" }}>
                                                    No records found
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            tableCheckingData.map((row: any, index) => (
                                                <React.Fragment key={index}>
                                                    {/* Main Row */}
                                                    <TableRow sx={{ backgroundColor: index % 2 === 0 ? "#f1f3f4" : "#fff" }}>
                                                        <TableCell align="center" sx={{ border: "1px solid #ddd", font: '400 18px/1.2 "Inter", sans-serif' }}>
                                                            {dayjs(row.postingDate).format("MM/DD/YYYY HH:mm:ss A")}
                                                            <IconButton size="small" onClick={() => handleExpandClick(index, row)}>
                                                                {expandedRow === index ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell align="left" sx={{ border: "1px solid #ddd", font: '400 18px/1.2 "Inter", sans-serif' }}>{row.transactionDesc}</TableCell>
                                                        <TableCell align="center" sx={{ border: "1px solid #ddd", font: '400 18px/1.2 "Inter", sans-serif' }}>{row.transactionCheckReference === "0" ? "" : row.transactionCheckReference}</TableCell>
                                                        <TableCell align="right" sx={{ color: "green", border: "1px solid #ddd", font: '400 18px/1.2 "Inter", sans-serif' }}>
                                                            {row.masterTransactionType === "CR DET" ? formatAmount(row.amount) : ''}
                                                        </TableCell>
                                                        <TableCell align="right" sx={{ color: "red", border: "1px solid #ddd", font: '400 18px/1.2 "Inter", sans-serif' }}>
                                                            {row.masterTransactionType === "DB DET" ? formatAmount(row.amount) : ''}
                                                        </TableCell>
                                                    </TableRow>

                                                    {/* Expandable Row */}
                                                    <TableRow>
                                                        <TableCell colSpan={5} sx={{ padding: 0, border: "none", font: '400 18px/1.2 "Inter", sans-serif' }}>
                                                            <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                                                                <Box sx={{ padding: "10px 20px", backgroundColor: "#F9F9F9" }}>
                                                                    {/* === CHECK IMAGE DISPLAY === */}
                                                                    {row.transactionCheckReference && checkImageData[index] && (
                                                                        <Box
                                                                            sx={{
                                                                                mb: 2,
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                gap: 2,
                                                                            }}
                                                                        >
                                                                            {typeof checkImageData[index] === "object" && checkImageData[index] !== null ? (
                                                                                <>
                                                                                    {((checkImageData[index] as { front: string; back: string }).front) && (
                                                                                        <img
                                                                                            src={`data:image/png;base64,${(checkImageData[index] as { front: string; back: string }).front}`}
                                                                                            alt="Check Front"
                                                                                            style={{ maxWidth: "100%", height: "auto" }}
                                                                                        />
                                                                                    )}
                                                                                    {((checkImageData[index] as { front: string; back: string }).back) && (
                                                                                        <img
                                                                                            src={`data:image/png;base64,${(checkImageData[index] as { front: string; back: string }).back}`}
                                                                                            alt="Check Back"
                                                                                            style={{ maxWidth: "100%", height: "auto" }}
                                                                                        />
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <img
                                                                                    src={`data:image/png;base64,${checkImageData[index]}`}
                                                                                    alt="Check"
                                                                                    style={{ maxWidth: "100%", height: "auto" }}
                                                                                />
                                                                            )}

                                                                        </Box>
                                                                    )}
                                                                    {/* === LINKS AS BUTTONS: Front | Back | Both === */}
                                                                    {row.transactionCheckReference && <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, mb: 2 }}>
                                                                        <Button variant="text" onClick={() => handleGetCheckImage(row, index, "front")}>{translate("front")}</Button>
                                                                        <Button variant="text" onClick={() => handleGetCheckImage(row, index, "back")}>{translate("back")}</Button>
                                                                        <Button variant="text" onClick={() => handleGetCheckImage(row, index, "both")}>{translate("both")}</Button>
                                                                        <Button variant="text" onClick={() => handlePrintImage(row, index, selectedPrintView)}>{translate("print")}</Button>
                                                                    </Box>}
                                                                    {/* === EXISTING TEXT FIELD === */}
                                                                    <CustomTextField
                                                                        labelText={translate("notes")}
                                                                        multiline
                                                                        rows={3}
                                                                        value={descriptionMap[index] || ""}
                                                                        onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                                                        onBlur={() => handleDescriptionBlur(index, row)}
                                                                        inputProps={{ maxLength: 100 }}
                                                                        readOnly={[constants.ROLES_BUDGET_ANALYST,
                                                                        constants.ROLES_PROJECT_ANALYST,
                                                                        constants.ROLES_READ_ONLY_USER,
                                                                        constants.ROLES_PROJECT_APPROVER,
                                                                        constants.ROLES_READ_ONLY_ALL_LOCATIONS].includes(userInfo?.roles?.roleName ?? '')}
                                                                    />
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            ))
                                        )}
                                    </TableBody>

                                </StyledTable>
                            </TableContainer>

                            {/* Pagination Section */}
                            {totalEntries > 4 && (
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    spacing={2}
                                    sx={{ width: "100%", padding: "10px", marginTop: 2 }}
                                >
                                    {/* Left: Showing Total Entries */}
                                    <Typography variant="body2" sx={{ fontSize: "18px" }}>
                                        Showing {(page * rowsPerPage) + 1}–
                                        {Math.min((page + 1) * rowsPerPage, totalEntries)} of {totalEntries} entries
                                    </Typography>

                                    {/* Center: Rows Per Page Selection */}
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Typography variant="body2" sx={{ marginRight: 1, fontSize: "18px" }}>Show:</Typography>
                                        <Autocomplete
                                            sx={{ width: 70, fontSize: "18px" }}
                                            size="small"
                                            disableClearable
                                            options={CommonUtilities.paginationOptions ?? []}
                                            getOptionLabel={(option) => option.toString()}
                                            value={rowsPerPage}
                                            onChange={(event, newValue) => {
                                                if (newValue !== null) {
                                                    setRowsPerPage(newValue);
                                                    setPage(0); // Reset to first page
                                                }
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                        <Typography variant="body2" sx={{ fontSize: "18px" }} ml={1}>entries</Typography>
                                    </Box>

                                    {/* Right: Pagination Controls */}
                                    <Pagination
                                        count={Math.ceil(totalEntries / rowsPerPage)} // Total number of pages
                                        page={page + 1} // Because MUI Pagination is 1-based
                                        onChange={(e, newPage) => {
                                            setPage(newPage - 1); // Convert to 0-based index
                                            setExpandedRow(null); // Collapse any expanded rows
                                        }} // Convert to 0-based
                                        showFirstButton
                                        showLastButton
                                    />
                                </Stack>
                            )}
                        </Box>
                        <Box className="right-fields" >
                            <ContainedButton onClick={handleBack} sx={{ mt: 2 }}>
                                Back
                            </ContainedButton>
                        </Box>
                    </Box>
                    <FilterPopUpBankDetails
                        open={openPopUp}
                        handleClose={handlePopUpClose}
                        montlyEndDateList={montlyEndDateList}
                        saveChanges={handleConfirm}
                        titleMessage={titleName}
                        selectBaiCode={selectedBaiCode}
                        onResetFilters={() => setSelectedBaiCode(baiCodeOptions[0])}
                    />
                    <Backdrop
                        sx={(theme) => ({
                            color: "#fff",
                            zIndex: theme.zIndex.drawer + 1,
                            display: "flex",
                            flexDirection: "column",
                        })}
                        open={blackdropFlag}
                    >
                        <CircularProgress color="inherit" />
                        <Typography color="white">Please wait...</Typography>
                    </Backdrop>
                </StyledTwoChildContainer>
            </StyledOneChildContainer>
        </StyledParentContainer>
    );
}

export default SummaryDetails;



